import type { FC } from 'react';

import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface MicLoadingStateProps {
  className?: string;
}

export const MicLoadingState: FC<MicLoadingStateProps> = ({
  className = '',
}) => {
  return (
    <div
      className={`vai-flex vai-items-center vai-gap-4 vai-p-6 vai-bg-white ${className}`}
    >
      {/* Loading Microphone Icon */}
      <div className="vai-relative vai-flex-shrink-0">
        <div className="vai-relative vai-w-32 vai-h-32 vai-flex vai-items-center vai-justify-center">
          {/* Outer subtle ring - light blue */}
          <div className="vai-absolute vai-w-28 vai-h-28 vai-rounded-full vai-bg-blue-200 vai-opacity-60"></div>
          {/* Middle subtle ring - medium blue */}
          <div className="vai-absolute vai-w-24 vai-h-24 vai-rounded-full vai-bg-blue-300 vai-opacity-70"></div>
          {/* Inner circle - dark blue with gentle pulse */}
          <div
            className="vai-relative vai-w-20 vai-h-20 vai-rounded-full vai-bg-blue-500 vai-flex vai-items-center vai-justify-center vai-z-10 vai-animate-pulse"
            style={{ animationDuration: '3s' }}
          >
            <FontAwesomeIcon
              icon={faMicrophone}
              className="vai-text-white vai-text-3xl"
            />
          </div>
        </div>
      </div>

      {/* Loading Status Text */}
      <div className="vai-flex vai-flex-col vai-gap-1">
        <p className="vai-font-bold vai-text-lg vai-text-gray-900">
          Setting up microphone
        </p>
        <p className="vai-text-sm vai-text-gray-600">Preparing for note</p>
      </div>
    </div>
  );
};
